import React, {Component} from 'react';
// import {Row, Col} from "reactstrap";
import {Textfit} from 'react-textfit';
import {connect} from 'react-redux';

class Screen extends Component {

  render() {
    let {results} = this.props;
    return (
      <div>
        {results ? <div className={"event-body-wrapper"}>
          <Textfit mode={"multi"} style={{height: '75vh'}} className={"text-wrapper_"}>
            {results.question_content}
          </Textfit>
        </div> : null}
      </div>

    );
  }
}

const mapStateToProps = (state) => ({
  results: state.socketReducer.result
});

export default connect(mapStateToProps)(Screen);
